/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-misused-promises */
import {
  Button,
  Combobox,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Textarea,
} from "@repo/ui";
import React, { useContext, useRef } from "react";
import type { UseFormReturn } from "react-hook-form";
import { useForm, useFieldArray } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { LookUpContext } from "utils/reducers/lookup";
import type { BagType, CoinsDenom, Currency } from "utils/types/lookup.type";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { ListPlus, PlusCircle, TrashIcon } from "lucide-react";
import { useGetAllBagTypes } from "utils/apis/lookups.api";
import {
  BAG_COINS_DENOMINATIONS,
  BOX_COINS_DENOMINATIONS,
  SEAL_NUMBER_REGEX,
} from "utils/constant";
import { showToast } from "utils/helper";

const formSchema = z
  .object({
    consignmentType: z
      .string()
      .min(1, { message: "Consignment Type is required." }),
    containerType: z.string().min(1, { message: "Bag Type is required." }),
    containerId: z.string().min(1, { message: "ContainerId is required." }),
    details: z.string().optional(),
    currency: z.string().min(1, { message: "Currency is required." }),
    declaredValue: z
      .number()
      .min(0, { message: "Declared Value can not be negative." }),
    exchangeRate: z
      .number()
      .min(0.001, { message: "Exchange Rate is required." }),
    count: z.number().min(1, { message: "Count is required." }),

    sealNo: z.string().optional().default(""),
    remarks: z.string().optional(),
    packedCurrencies: z.array(
      z.object({
        currency: z.string(),
        declaredValue: z.number(),
        exchangeRate: z.number(),
      }),
    ),
    denominations: z.array(
      z.object({
        denomination: z.string(),
        shape: z.string(),
        count: z.number(),
      }),
    ),
  })
  .superRefine((val, ctx) => {
    if (!val.sealNo && val.consignmentType !== "Coins") {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["sealNo"],
        message: "Seal no. is required.",
      });
      return true;
    }

    if (val.sealNo && !SEAL_NUMBER_REGEX.test(val.sealNo)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["sealNo"],
        message: "Invalid seal no. format.",
      });
      return true;
    }

    if (val.consignmentType === "Coins" && !val.details) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["details"],
        message: "Coin denomination is required.",
      });
      return true;
    }
  });
export default function AddContainers({
  consignments,
  setConsignments,
  type,
}: {
  consignments: any[];
  setConsignments: React.Dispatch<React.SetStateAction<any[]>>;
  type:
    | "B2B"
    | "Delivery"
    | "Kiosk Service"
    | "Replenishment"
    | "Clearance"
    | "Collection"
    | "Exchange";
}) {
  const { currencies, coinContainers } = useContext(LookUpContext);
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      consignmentType: "",
      containerType: "",
      containerId: "",
      details: "",
      currency: "",
      declaredValue: 0,
      exchangeRate: 1,
      count: 1,
      sealNo: "",
      remarks: "",
      packedCurrencies: [],
      denominations: [],
    },
  });

  const isCurrencyDisabled = useRef(false);
  const { control } = form;
  const { fields, append, remove } = useFieldArray({
    control,
    name: "packedCurrencies",
  });

  const { data: allBagTypes } = useGetAllBagTypes(type);
  const consignmentType = form.watch("consignmentType");
  const containerType = form.watch("containerType");

  const handleChangeBagType = (val: string) => {
    const selectedBag = (allBagTypes as BagType[])?.find(
      (i) => i.description === val,
    );
    if (selectedBag) {
      form.setValue("consignmentType", selectedBag.consignmentType);
      form.setValue("containerId", String(selectedBag.code));
      if (
        selectedBag.consignmentType === "Coins" ||
        selectedBag.currencyType === "AED"
      ) {
        form.setValue("currency", "AED");
        isCurrencyDisabled.current = true;
      } else {
        isCurrencyDisabled.current = false;
      }
    }
  };

  const handleChangeCurrency = (val: string) => {
    const selectedCurr = (currencies as Currency[])?.find(
      (i) => i.shortName === val,
    );
    if (selectedCurr) {
      form.setValue("exchangeRate", selectedCurr?.exchangeRate || 1);
    }
  };

  function onSubmit(values: z.infer<typeof formSchema>) {
    if (containerType === "Foreign Currency") {
      values.currency = "FC";
      values.exchangeRate = 1;
      values.declaredValue = values.packedCurrencies?.reduce(
        (acc, curr) => acc + (curr.declaredValue * curr.exchangeRate || 0),
        0,
      );
    }
    if (values.consignmentType === "Coins") {
      const selectedCoin = (coinContainers as CoinsDenom[])?.find(
        (i) =>
          i.denomination === values.details &&
          i.containerType === containerType,
      );
      if (selectedCoin) {
        values.declaredValue = selectedCoin?.valuePerContainer * values.count;
      }
    }

    if (values.sealNo) {
      const isSealScanned = consignments.find(
        (i) => i.sealNo === values.sealNo,
      );
      if (isSealScanned) {
        showToast("error", "Seal No. already exists.");
        return;
      }
    }

    setConsignments((prev) => [
      ...prev,
      {
        ...values,
        deleteId: crypto.randomUUID(),
        ...(type === "Exchange" ? { status: "Collected" } : {}),
      },
    ]);
    form.reset();
  }

  function DeleteCell(props: any) {
    const { dataIndex } = props;
    return (
      <td {...props}>
        <TrashIcon
          className="text-red-500 cursor-pointer"
          type="button"
          onClick={() => {
            remove(dataIndex);
          }}
        />
      </td>
    );
  }

  return (
    <Form {...form}>
      <form
        id="collection-form"
        onSubmit={form.handleSubmit(onSubmit)}
        className="gap-4 grid grid-cols-2"
      >
        <FormCombobox
          form={form}
          data={allBagTypes?.map((item: BagType) => ({
            label: item?.description,
            value: item?.description,
          }))}
          name="containerType"
          label="Bag Type"
          placeholder="Select Bag Type"
          onChange={handleChangeBagType}
        />
        {containerType !== "Foreign Currency" ? (
          <FormCombobox
            form={form}
            data={currencies.map((item: Currency) => ({
              label: item?.name,
              value: item?.shortName,
            }))}
            name="currency"
            label="Currency"
            placeholder="Select Currency"
            onChange={handleChangeCurrency}
            disabled={isCurrencyDisabled.current}
          />
        ) : null}

        {consignmentType === "Coins" ? (
          <>
            <FormSelect
              form={form}
              data={
                containerType === "Coins Box"
                  ? BOX_COINS_DENOMINATIONS
                  : BAG_COINS_DENOMINATIONS
              }
              name="details"
              label="Coin Denomination"
              placeholder="Select Denomination"
            />
            <FormField
              control={form.control}
              name="count"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Count</FormLabel>
                  <FormControl>
                    <NumericTextBox
                      step={0}
                      spinners={false}
                      min={1}
                      className="w-full h-10"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </>
        ) : (
          <>
            {containerType !== "Foreign Currency" ? (
              <FormField
                control={form.control}
                name="declaredValue"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Declared Value</FormLabel>
                    <FormControl>
                      <NumericTextBox
                        step={0}
                        spinners={false}
                        min={0}
                        className="w-full h-10"
                        {...field}
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
            ) : null}
            <FormField
              control={form.control}
              name="sealNo"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Seal No.</FormLabel>
                  <FormControl>
                    <Input type="text" placeholder="Seal no." {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </>
        )}

        {containerType === "Foreign Currency" ? (
          <div className="w-full col-span-2">
            <div className="grid grid-cols-[1fr_1fr_max-content]  items-end gap-3 mb-3">
              <FormCombobox
                form={form}
                data={currencies.map((item: Currency) => ({
                  label: item?.name,
                  value: item?.shortName,
                }))}
                name="currency"
                label="Foreign Currency"
                placeholder="Select Currency"
                onChange={handleChangeCurrency}
              />
              <FormField
                control={form.control}
                name="declaredValue"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Declared Value</FormLabel>
                    <FormControl>
                      <NumericTextBox
                        step={0}
                        spinners={false}
                        min={0}
                        className="w-full h-10"
                        {...field}
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <Button
                variant="secondary"
                size="icon"
                type="button"
                onClick={() => {
                  append({
                    currency: form.getValues("currency"),
                    exchangeRate: form.getValues("exchangeRate"),
                    declaredValue: form.getValues("declaredValue"),
                  });
                }}
              >
                <PlusCircle />
              </Button>
            </div>
            <Grid data={fields} className="my-3">
              <GridColumn field="currency" title="Currency" />
              <GridColumn field="declaredValue" title="Value" format="{0:N2}" />
              <GridColumn field="exchangeRate" title="Exchange Rate" />
              <GridColumn field="deleteId" title="Remove" cell={DeleteCell} />
            </Grid>
          </div>
        ) : null}

        <FormField
          control={form.control}
          name="remarks"
          render={({ field }) => (
            <FormItem className="col-span-2">
              <FormLabel>Remarks</FormLabel>
              <FormControl>
                <Textarea placeholder="Remarks..." {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <div className="flex gap-2 justify-end col-span-2">
          <Button variant="secondary" type="submit" className="gap-3">
            <ListPlus /> Add
          </Button>
        </div>
      </form>
    </Form>
  );
}

function FormSelect({
  form,
  name,
  label,
  placeholder,
  data,
  onChange,
  disabled,
}: {
  form: UseFormReturn<z.infer<typeof formSchema>>;
  name: keyof z.infer<typeof formSchema>;
  label: string;
  placeholder?: string;
  data?: { label: string; value: string | number }[];
  onChange?: (e: string) => void;
  disabled?: boolean;
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Select
            onValueChange={(e) => {
              field.onChange(e);
              onChange?.(e);
            }}
            value={field.value as string}
            disabled={disabled}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {data?.map((item) => (
                <SelectItem key={item.value} value={String(item.value)}>
                  {item.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

function FormCombobox({
  form,
  name,
  label,
  placeholder,
  data,
  onChange,
  disabled,
  ...props
}: {
  form: UseFormReturn<z.infer<typeof formSchema>>;
  name: keyof z.infer<typeof formSchema>;
  label: string;
  placeholder: string;
  data?: { label: string; value: any }[];
  disabled?: boolean;
  onChange?: (e: any) => void;
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Combobox
            value={field.value as any}
            setValue={(e: string) => {
              field.onChange(e);
              onChange?.(e);
            }}
            data={data}
            placeholder={placeholder}
            disabled={disabled}
            {...props}
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
